import "./setter-top-client-table.css";
import { MdDelete, MdModeEdit } from "react-icons/md";
import Swal from "sweetalert2";
import {
  addData,
  getData,
  formService,
  getBtnEmmit,
  setConfirmationModal,
  formResetService,
  removeDataByIndex,
  updateDataByIndex
} from "./setter-form-service";
import { useEffect, useRef, useState } from "react";
import { IoMdAdd } from "react-icons/io";

function SetterCreditClientTable({ creditClientObj }) {

  const [records, setRecords] = useState([]);
  const [isAdding, setIsAdding] = useState(false); 
  const [editIndex, setEditIndex] = useState(null); 

  const [newRow, setNewRow] = useState({
    content: "",
    number_pallets: "",
    awb: ""
  });

  const newRowRef = useRef(newRow);
  const recordsRef = useRef(records);
  const creditClientObjRef = useRef(creditClientObj);

  useEffect(() => {
    newRowRef.current = newRow;
  }, [newRow]);

  useEffect(() => {
    recordsRef.current = records;
  }, [records]);

  useEffect(() => {
    creditClientObjRef.current = creditClientObj;
  }, [creditClientObj]);

  const isRecordValid = (record) => {
    if (!record) return false;
    if (!record.content || !record.content.trim()) return false;
    if (!record.awb || !/^[0-9]{4}$/.test(record.awb)) return false;
    if (!record.number_pallets || Number(record.number_pallets) <= 0) return false;
    return true;
  };

  const captureRowHasData = (row) => {
    if (!row) return false;
    const hasAwb = Boolean(row.awb && row.awb.trim() !== "");
    const hasPallets = Boolean(row.number_pallets && String(row.number_pallets).trim() !== "");

    return hasAwb || hasPallets;
  };


  useEffect(() => {
    const subscription = formService.formSubmitSubject.subscribe(async () => {
      if (!getBtnEmmit()) return;

      const pendingRow = newRowRef.current;
      const existingRecords = recordsRef.current;


      if (isAdding && captureRowHasData(pendingRow)) {
        const pendingShipment = {
          customer_name: creditClientObjRef.current
            ? creditClientObjRef.current.name
            : "Cliente no encontrado",
          content: pendingRow.content,
          number_pallets: pendingRow.number_pallets,
          awb: pendingRow.awb,
        };

        if (!isRecordValid(pendingShipment)) {
          Swal.fire(
            "Embarque incompleto",
            "El último embarque en captura tiene campos vacíos o inválidos. Revisa la mercancía, el AWB (4 dígitos) y las tarimas.",
            "warning"
          );
          return;
        }

        if (existingRecords.length >= 50) {
          Swal.fire(
            "Límite alcanzado",
            "Solo se permiten hasta 50 embarques por turno.",
            "warning"
          );
          return;
        }

        const updatedList = [...existingRecords, pendingShipment];
        setRecords(updatedList);
        recordsRef.current = updatedList;
        addData(pendingShipment);

  
        const clearedRow = { content: "", number_pallets: "", awb: "" };
        setNewRow(clearedRow);
        newRowRef.current = clearedRow;
        setIsAdding(false);
      }


      const currentData = getData();

      if (currentData.length < 1) {
        Swal.fire(
          "Sin embarques",
          "Debes agregar al menos un embarque antes de emitir el turno.",
          "warning"
        );
        return;
      }

      const invalidIndex = currentData.findIndex((record) => !isRecordValid(record));
      if (invalidIndex !== -1) {
        Swal.fire(
          "Registros incompletos",
          `El embarque #${invalidIndex + 1} tiene campos vacíos o inválidos.`,
          "warning"
        );
        return;
      }

    
      setConfirmationModal(true);
    });

    return () => subscription.unsubscribe();
  }, [isAdding]);

  useEffect(() => {
    const subscription = formResetService.onReset().subscribe(() => {
      setRecords([]);
      setNewRow({ content: "", number_pallets: "", awb: "" });
      setIsAdding(false);
      setEditIndex(null);
    });
    return () => subscription.unsubscribe();
  }, []);


  const handleRecordChange = (index, field, value) => {
    const updatedRecords = [...records];
    updatedRecords[index][field] = value;
    setRecords(updatedRecords);
    updateDataByIndex(index, updatedRecords[index]);
  };

  const handleNewRowChange = (field, value) => {
    setNewRow((prev) => ({
      ...prev,
      [field]: value
    }));
  };


  const handleDeleteRow = (index) => {

    removeDataByIndex(index);
    setRecords([...getData()]);

  };


  const handleAddShipment = () => {
    if (records.length >= 50) {
      Swal.fire("Límite alcanzado", "Solo se permiten hasta 50 embarques por turno.", "warning");
      return;
    }

    if (!isAdding) {
      setNewRow({
        content: records.length > 0 ? records[0].content : "",
        number_pallets: "",
        awb: ""
      });
      setIsAdding(true);
      return;
    }

    if (!newRow.content.trim()) {
      Swal.fire("Campo requerido", "Debes ingresar la información de la mercancía.", "warning");
      return;
    }
    if (!newRow.awb || !/^[0-9]{4}$/.test(newRow.awb)) {
      Swal.fire("AWB inválido", "El AWB debe contener exactamente 4 números.", "warning");
      return;
    }
    if (!newRow.number_pallets || Number(newRow.number_pallets) <= 0) {
      Swal.fire("Cantidad inválida", "La cantidad de tarimas debe ser mayor a 0.", "warning");
      return;
    }

    const shipment = {
      customer_name: creditClientObj ? creditClientObj.name : "Cliente no encontrado",
      content: newRow.content,
      number_pallets: newRow.number_pallets,
      awb: newRow.awb,
    };

    const updatedList = [...records, shipment];
    setRecords(updatedList);
    addData(shipment);

    setNewRow({
      content: updatedList[0].content, 
      number_pallets: "",
      awb: ""
    });
  };

  return (
    <>
      <div className="records">
        <table className="table-format-shepments">
          <thead>
            <tr className="table-header">
              <th className="table-header-cell">Cliente</th>
              <th className="table-header-cell">Descripción / Contenido</th>
              <th className="table-header-cell">AWB (4 dígitos)</th>
              <th className="table-header-cell">Tarimas</th>

            </tr>
          </thead>
          <tbody>
            {/* Si no hay registros ni fila activa, muestra el mensaje */}
            {records.length === 0 && !isAdding && (
              <tr>
                <td colSpan="4" className="text-center">
                  No hay embarques agregados.
                </td>
              </tr>
            )}

            {/* Registros previamente guardados */}
            {records.map((item, index) => (
              <tr key={index}>
                <td className="borderStyle">{item.customer_name}</td>
                <td className="borderStyle">
                  <input
                    type="text"
                    className="formInputInline"
                    value={item.content}
                    onChange={(e) => handleRecordChange(index, "content", e.target.value)}
                  />
                </td>
                <td className="borderStyle">
                  <input
                    type="text"
                    maxLength={4}
                    className="formInputInline"
                    value={item.awb}
                    onChange={(e) =>
                      handleRecordChange(index, "awb", e.target.value.replace(/[^0-9]/g, ""))
                    }
                  />
                </td>
                <td className="borderStyle" style={{ borderRight: "1px solid #000" }}>
                  {/* Contenedor flex para colocar el ícono de eliminar justo al lado del input */}
                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <input
                      type="text"
                      className="formInputInline"
                      value={item.number_pallets}
                      onChange={(e) =>
                        handleRecordChange(index, "number_pallets", e.target.value.replace(/[^0-9]/g, ""))
                      }
                    />
                  </div>
                </td>
                <td className="spacing-cell"></td>
                <td className="text-center actionTdSeek">
                  <div
                    className="box-container seek-bg-red"
                    onClick={() => handleDeleteRow(index)}
                    style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
                  >
                    <MdDelete />
                  </div>

                </td>
              </tr>
            ))}

            {/* Fila en blanco para captura activa */}
            {isAdding && records.length < 50 && (
              <tr className="capture-row">
                <td className="borderStyle">
                  <strong>{creditClientObj ? creditClientObj.name : "Cliente actual"}</strong>
                </td>
                <td className="borderStyle">
                  <input
                    type="text"
                    className="formInputInline"
                    placeholder="Descripción*"
                    maxLength={240}
                    value={newRow.content}
                    onChange={(e) => handleNewRowChange("content", e.target.value)}
                  />
                </td>
                <td className="borderStyle">
                  <input
                    type="text"
                    className="formInputInline"
                    placeholder="4 dígitos *"
                    maxLength={4}
                    value={newRow.awb}
                    onChange={(e) =>
                      handleNewRowChange("awb", e.target.value.replace(/[^0-9]/g, ""))
                    }
                  />
                </td>
                <td className="borderStyle" style={{ borderRight: "1px solid #000" }}>
                  <input
                    type="text"
                    className="formInputInline"
                    placeholder="Cantidad *"
                    value={newRow.number_pallets}
                    onChange={(e) =>
                      handleNewRowChange("number_pallets", e.target.value.replace(/[^0-9]/g, ""))
                    }
                  />
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <button
        className="btn-add-shipment"
        disabled={records.length >= 50}
        onClick={handleAddShipment}
      >
        <IoMdAdd /> Agregar embarque
      </button>
    </>
  );
}

export default SetterCreditClientTable;